import { genderTypes } from "pages/profilePage/models";
import personTypes from "pages/profilePage/models/personTypes";
import { parse, format } from 'date-fns';

export const ShippingAddressFormat = (AddressObject, participantObject) => {
  const birthDate = participantObject.birthDate?.value;
  const FormattedDate = birthDate ? format(parse(birthDate, 'dd/MM/yyyy', new Date()), "yyyy-MM-dd'T'HH:mm:ssxxx") : null;

    const output = {
      customer: {
        name: participantObject.name?.value || '',
        documentNumber: participantObject.cpfCnpj?.value || '',
        email: participantObject.email?.value || '',
        genderType: (participantObject.genderType?.value && genderTypes[participantObject.genderType?.value]) || '',
        personType: (participantObject.personType && personTypes[participantObject.personType]) || '',
        birthDate: FormattedDate || '',
      },
      shippingAddress: {
        zipCode: AddressObject.zipCode?.value || '',
        receiver: AddressObject.name?.value || '',
        number: AddressObject.number?.value || '',
        complement: AddressObject.complement?.value || 'Nenhum',
        reference: AddressObject.reference?.value || 'Nenhum',
        street: AddressObject.street?.value || '',
        district: AddressObject.district?.value || '',
        city: AddressObject.city?.value || '',
        state: AddressObject.state?.value || ''
      }
    };

    output.customer.phones = [];
    if (participantObject.phones?.mobile?.number) {
      output.customer.phones.push({
        areaCode: participantObject.phones.mobile.areaCode || '',
        number: participantObject.phones.mobile.number || '',
        type: participantObject.phones.mobile.type || ''
      });
    }
    if (participantObject.phones?.home?.number) {
      output.customer.phones.push({
        areaCode: participantObject.phones.home.areaCode || '',
        number: participantObject.phones.home.number || '',
        type: participantObject.phones.home.type || ''
      });
    }
    if (participantObject.phones?.work?.number) {
      output.customer.phones.push({
        areaCode: participantObject.phones.work.areaCode || '',
        number: participantObject.phones.work.number || '',
        type: participantObject.phones.work.type || ''
      });
    }
    return output;
  }